import type { ClientErrors } from '@client-info/utils/orpc';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { isDefinedError } from '@orpc/client';
import { ConnectErrorEnum } from '@server/pnr/pnr.dto';
import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { BackToConcurButton } from '../BackToConcurButton';
import { SupportText } from '../SupportText';
import { ErrorPageWrapper, Title } from '../styled';

interface ErrorPageProps {
  error: unknown;
}

export const ErrorPage = ({ error }: ErrorPageProps): ReactElement => {
  const { t } = useTranslation('integrations');

  const typedError = error as ClientErrors['pnr']['connect'];
  const isTokenValidationFailed =
    isDefinedError(typedError) &&
    (typedError.code === 'CONNECT_ERROR_401' ||
      typedError.code === 'CONNECT_ERROR_400') &&
    typedError.data.error === ConnectErrorEnum.TokenValidationFailed;

  const title = isTokenValidationFailed
    ? t('integration/sapConcur.verificationInvalid.title')
    : t('integration/sapConcur.serverError.title');

  const body = isTokenValidationFailed
    ? t('integration/sapConcur.verificationInvalid.body')
    : t('integration/sapConcur.serverError.body');

  return (
    <Grid size={{ xs: 12, sm: 6 }}>
      <ErrorPageWrapper component="section">
        <Title variant="h1">{title}</Title>
        <Typography sx={{ textAlign: 'center' }} variant="body1">
          {body}
        </Typography>
        <BackToConcurButton />
        <SupportText />
      </ErrorPageWrapper>
    </Grid>
  );
};
